/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMlCluster = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13 17a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
        <path d="M8.732 2.732a2.5 2.5 0 1 1 3.102 3.88l.439 3.511a2.489 2.489 0 0 1 1.698 2.02l3.957 1.413a2.5 2.5 0 1 1-.196 3.712 2.492 2.492 0 0 1-.725-1.918l-3.567-1.275a2.497 2.497 0 0 1-3.621.271L6.953 16.02a2.5 2.5 0 1 1-1.146-1.648L9 12.508a2.492 2.492 0 0 1 1.281-2.19l-.425-3.405a2.5 2.5 0 0 1-1.124-4.18z" />
        <path d="M5 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm14-6a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgMlCluster as MlCluster };
